<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '求人確認' }]"
        title="掲載前の求人"
      />
      <div class="grid-x align-justify">
        <div>
          <p>掲載前の求人を確認します。</p>
        </div>
      </div>
      <section>
        <h3 class="boss-joboffer-title boss-setting">
          求人情報プレビュー
        </h3>
        <p class="boss-text margin-top-0 margin-bottom-1">
          修正に関するコメント、制作担当とのメッセージ確認は「求人」ボタンからご確認ください。
        </p>
        <table class="unstriped hover boss-table">
          <thead>
            <tr>
              <th class="boss-table-head-center">
                求人ID
              </th>
              <th class="boss-table-head-center">
                管理用求人名
              </th>
              <th class="boss-table-head-center">
                求人名
              </th>
              <th class="boss-table-head-center">
                掲載サイズ
              </th>
              <th class="boss-table-head-center">
                プレビュー
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="!isEmptyJob">
              <tr
                v-for="(job, i) in jobs"
                :key="i"
              >
                <td
                  class="boss-table-data"
                  data-test="job-id"
                >
                  {{ job.offerId | parseOfferId }}
                </td>
                <td
                  class="boss-table-data"
                  data-test="job-management-name"
                >
                  {{ job.managementName }}
                </td>
                <td
                  class="boss-table-data left"
                  data-test="job-name"
                >
                  {{ job.name }}
                </td>
                <td
                  class="boss-table-data"
                  data-test="job-publish-size"
                >
                  {{ job.publishSize }}
                </td>
                <td class="boss-table-data">
                  <button
                    class="boss-button pega-preview-button margin-03"
                    data-test="job-confirmation-button"
                    @click="windowOpenPreview('previewJobEdit', job.id)"
                  >
                    求人
                  </button>
                  <button
                    class="boss-button pega-preview-button margin-03"
                    data-test="job-search-preview-button"
                    @click="openOfferSearchPreview(job.searchPreviewUrl)"
                  >
                    検索一覧
                  </button>
                  <button
                    v-if="job.companyMessageUrl"
                    class="boss-button pega-preview-button margin-03"
                    data-test="job-company-message-button"
                    @click="openCompanyMessagePreview(job.companyMessageUrl)"
                  >
                    企業メッセージ
                  </button>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td
                colspan="3"
                data-test="jobs-no-data"
              >
                ※掲載前確認中の求人情報はありません
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <section class="margin-top-1">
        <h3 class="boss-joboffer-title boss-setting">
          企業情報プレビュー
        </h3>
        <table class="unstriped hover boss-table">
          <thead>
            <tr>
              <th class="boss-table-head-center">
                企業ID
              </th>
              <th class="boss-table-head-center">
                企業名
              </th>
              <th class="boss-table-head-center">
                プレビュー
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!isEmptyCompany">
              <td
                class="boss-table-data"
                data-test="company-id"
              >
                {{ company.id }}
              </td>
              <td
                class="boss-table-data"
                data-test="company-name"
              >
                {{ company.name }}
              </td>
              <td class="boss-table-data">
                <button
                  v-if="company.url"
                  class="boss-button"
                  data-test="company-url"
                  @click="openCompanyDetailPreview(company.url)"
                >
                  企業情報
                </button>
              </td>
            </tr>
            <tr v-else>
              <td
                colspan="3"
                data-test="company-no-data"
              >
                ※掲載前確認中の企業情報はありません
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>
<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import _ from 'lodash'

export default {
  components: {
    SettingHeader
  },
  filters: {
    parseOfferId (val) {
      return (val) || '新規'
    }
  },
  data () {
    return {
      jobs: [],
      company: {}
    }
  },
  computed: {
    isEmptyJob () {
      return !this.jobs.length
    },
    isEmptyCompany () {
      return _.isEmpty(this.company)
    }
  },
  created () {
    this.fetchPrepublish()
  },
  methods: {
    fetchPrepublish () {
      this.$http.secured.get('/preview/edit/jobs').then(response => {
        this.$set(this, 'jobs', response.data.jobs)
        this.$set(this, 'company', response.data.company)
      })
    },
    windowOpenPreview (name, jobId) {
      const routeData = this.$router.resolve({ name: name, params: { jobId: jobId } })
      window.open(routeData.href, '_blank')
    },
    openOfferSearchPreview (searchPreviewUrl) {
      this.$http.secured.get('/preview/preview_code').then(response => {
        window.open(searchPreviewUrl + '&previewCode=' + response.data, '_blank')
      })
    },
    // USER側の検索一覧プレビューにアクセス
    openCompanyMessagePreview (companyMessageUrl) {
      this.$http.secured.get('/preview/preview_code').then(response => {
        window.open(companyMessageUrl + '&previewCode=' + response.data, '_blank')
      })
    },
    // USER側の企業メッセージプレビューにアクセス
    openCompanyDetailPreview (companyDetailUrl) {
      this.$http.secured.get('/preview/preview_code').then(response => {
        window.open(companyDetailUrl + '?previewCode=' + response.data, '_blank')
      })
    }
  }
}
</script>
